import { render } from "./Tem.vue?vue&type=template&id=32aa0c3e&scoped=true&lang=pug"
import script from "./Tem.vue?vue&type=script&lang=js"
export * from "./Tem.vue?vue&type=script&lang=js"

import "./Tem.vue?vue&type=style&index=0&id=32aa0c3e&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aa0c3e"]])

export default __exports__